import { render, staticRenderFns } from "./model-fix-cancel-order-items.vue?vue&type=template&id=4d352d20&"
import script from "./model-fix-cancel-order-items.vue?vue&type=script&lang=js&"
export * from "./model-fix-cancel-order-items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/sw-41f73918-1793878079/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d352d20')) {
      api.createRecord('4d352d20', component.options)
    } else {
      api.reload('4d352d20', component.options)
    }
    module.hot.accept("./model-fix-cancel-order-items.vue?vue&type=template&id=4d352d20&", function () {
      api.rerender('4d352d20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/roadrunner/Application/ViewComponents/Model/Fix/ModelFixCancelOrderItemsComponent/model-fix-cancel-order-items.vue"
export default component.exports